"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bignumber_1 = require("@ethersproject/bignumber");
var units_1 = require("@ethersproject/units");
function parseBigInt(_value, decimals) {
    var value = Number(_value).toFixed(18);
    var bi18 = (0, units_1.parseEther)(value.toString());
    var divisor = bignumber_1.BigNumber.from(10).pow(18 - decimals);
    return bi18.div(bignumber_1.BigNumber.from(divisor));
}
exports.default = parseBigInt;
//# sourceMappingURL=parseBigInt.js.map